import { render } from "./autocomplete.vue?vue&type=template&id=56b69be2"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"
script.render = render

export default script